import {createContext, useContext, useState, ReactNode} from "react";
import {v4 as uuidv4} from "uuid";
import {Notification} from "../components/general/Notifications.tsx";
import {Notifications} from "../components/general/Notifications.tsx";

interface NotificationContextType {
    dispatch: (notification: Notification) => void;
    dismiss: (id: string) => void;
}

const NotificationContext = createContext<NotificationContextType | undefined>(undefined);

export function NotificationProvider({children}: { children: ReactNode }) {
    const [notifications, setNotifications] = useState<Array<Notification>>([]);

    function dismiss(id: string) {
        setNotifications((prevNotifications) => prevNotifications.filter((n) => n.id !== id));
    }

    function dispatch(notification: Notification) {
        const id = uuidv4();
        setNotifications((prevNotifications) => [...prevNotifications, {
            title: notification.title,
            description: notification.description,
            type: notification.type,
            id: id
        }]);

        setTimeout(() => {
            setNotifications((prevNotifications) => prevNotifications.filter((n) => n.id !== id));
        }, 5000);
    }

    return (
        <NotificationContext.Provider value={{dispatch, dismiss}}>
            <Notifications notifications={notifications} onDismiss={dismiss} />
            {children}
        </NotificationContext.Provider>
    );
}

export function useNotifications() {
    const context = useContext(NotificationContext);
    if (context === undefined) {
        throw new Error('useNotifications must be used within a NotificationProvider');
    }
    return context;
}
